// Onglet Portable FM — raccourcis vers les outils du portable France Metal (poste surf / clip / veille, IP résidentielle).
// Tailnet-only : nécessite Tailscale actif sur l'appareil. Les tuiles ouvrent l'outil dans un nouvel onglet.

const HOST = "france-metal-pc-portable.tail3ea350.ts.net"

type Tool = { name: string; icon: string; desc: string; url: string; tag: string; accent: string }

const TOOLS: Tool[] = [
  { name: "Hermes WebUI", icon: "⚡", desc: "Agent Hermes du portable (veille, sous-agents par site)", url: `http://${HOST}:8787`, tag: "Agent", accent: "#f59e0b" },
  { name: "Bureau Linux (capture)", icon: "🖥️", desc: "Chrome + Chromium + Obsidian + Web Clipper — le poste de clipping", url: `http://${HOST}:3014`, tag: "Capture", accent: "#22c55e" },
  { name: "Grist veille", icon: "📋", desc: "Tables de suivi des liens répertoriés (1 table par source)", url: `http://${HOST}:8484`, tag: "Veille", accent: "#84cc16" },
  { name: "Atelier Hermes", icon: "🛠️", desc: "Workspace Hermes — si la page ne s'ouvre pas, il faut le relancer (bug connu)", url: `http://${HOST}:3013`, tag: "Agent", accent: "#fb923c" },
  { name: "Fichiers (PC entier)", icon: "📂", desc: "Explorateur : C: + Disque-D, échange de fichiers (Echange)", url: `http://${HOST}:8085`, tag: "Fichiers", accent: "#eab308" },
  { name: "MeshCentral (parc)", icon: "🌐", desc: "Prendre la main à distance : écran, terminal, fichiers (appareil PORTABLE-FM)", url: "https://srv836585.tail3ea350.ts.net:4430", tag: "Parc", accent: "#0891b2" },
]

export default function PcFmPage() {
  return (
    <div style={{ height: "100%", overflowY: "auto", backgroundColor: "#111827" }}>
    <div style={{ padding: "24px", maxWidth: "1000px", margin: "0 auto" }}>
      <div style={{ marginBottom: "8px" }}>
        <h1 style={{ margin: 0, fontSize: "24px", color: "#e6edf3" }}>💻 Portable FM — france-metal-pc-portable</h1>
        <p style={{ color: "#8b949e", fontSize: "13px", marginTop: "6px" }}>
          Le poste <b>surf / clip / veille</b> (IP résidentielle, fixe à la maison, en Wi-Fi). Tailnet-only : <b>Tailscale doit être actif</b> sur ton appareil.
        </p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: "16px", marginTop: "20px" }}>
        {TOOLS.map((t) => (
          <a key={t.name} href={t.url} target="_blank" rel="noreferrer"
            style={{ display: "block", padding: "18px", borderRadius: "14px", background: "#161b22", border: "1px solid #30363d", textDecoration: "none", color: "#e6edf3", transition: "all .15s" }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = t.accent; e.currentTarget.style.transform = "translateY(-2px)" }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#30363d"; e.currentTarget.style.transform = "translateY(0)" }}
          >
            <div style={{ fontSize: "30px" }}>{t.icon}</div>
            <div style={{ fontWeight: 600, fontSize: "17px", margin: "8px 0 3px" }}>{t.name}</div>
            <div style={{ color: "#8b949e", fontSize: "12px", lineHeight: 1.4 }}>{t.desc}</div>
            <span style={{ display: "inline-block", fontSize: "10px", padding: "2px 8px", borderRadius: "20px", background: "#21262d", color: "#8b949e", marginTop: "10px" }}>{t.tag}</span>
          </a>
        ))}
      </div>

      <div style={{ marginTop: "28px", padding: "16px", borderRadius: "12px", background: "#161b22", border: "1px solid #30363d", color: "#8b949e", fontSize: "13px", lineHeight: 1.6 }}>
        <b style={{ color: "#e6edf3" }}>ℹ️ Aide-mémoire</b><br />
        • <b>Écran à distance</b> : RustDesk → adresse <b>100.70.36.78</b> (ou MeshCentral, appareil PORTABLE-FM).<br />
        • <b>Rôle</b> : surf / clipping / veille à rythme humain depuis l'IP de la maison (jamais l'IP du VPS). Outils agents = <b>conteneurs Docker</b>, jamais installés sur le Windows.<br />
        • <b>Docker Desktop</b> démarre avec Windows ; si un outil ne répond pas, vérifier qu'il tourne (Arcane / MeshCentral).<br />
        • Disque <b>C: presque plein</b> (≈ 18 Go libres) → stocker sur D:.
      </div>
    </div>
    </div>
  )
}
